module.exports = function() {
  return new Worker(__webpack_public_path__ + "a0423b7bafe0ac24dab6.worker.js");
};